<template>
    <div>
        <FormRowTwo
            :fieldNameArr="[$t('LENGTH') + '(mm)' + ': ', $t('WIDTH') + '(mm)' + ': ', $t('HEIGHT') + '(mm)' + ': ', $t('GROSS_WEIGHT') + '(g)' + ': ', $t('MODEL') + ': ']"
            :fieldWidthArr="[364, 364, 364, 364, 364]" :fieldSpanWidthArr="[102, 102, 102, 102, 102]">
            <Input class="Input" v-model="plasticQuotation.length" slot="a" :disabled="true" />
            <Input class="Input" v-model="plasticQuotation.width" slot="b" :disabled="true" />
            <Input class="Input" v-model="plasticQuotation.height" slot="c" :disabled="true" />
            <Input class="Input" v-model="plasticQuotation.weight" slot="d" :disabled="true" />
            <Input class="Input" v-model="plasticQuotation.deltaModel" slot="e" :disabled="true" />
        </FormRowTwo>
        <FormRowTwo
            :fieldNameArr="[$t('RESIN_TYPE') + ': ', $t('RESIN_VENDOR') + ': ', $t('RESIN_NO') + ': ', $t('DISTRIBUTOR') + ': ', $t('RESIN_COLOR') + ': ']"
            :fieldWidthArr="[364, 364, 364, 364, 364]" :fieldSpanWidthArr="[102, 102, 102, 102, 102]">
            <Input class="Input" v-model="resinType" slot="a" :disabled="true" />
            <Input class="Input" v-model="resinVendor" slot="b" :disabled="true" />
            <Input class="Input" v-model="resinNo" slot="c" :disabled="true" />
            <Input class="Input" v-model="distributor" slot="d" :disabled="true" />
            <Input class="Input" v-model="plasticQuotation.resinColor" slot="e" :disabled="true" />
        </FormRowTwo>
        <FormRowTwo
            :fieldNameArr="[$t('COLOR_NO') + ': ', $t('RM_PRICE') + ': ', $t('RM_PRICE_DATE') + ': ', $t('DYE_CSOT') + ': ', $t('CAVITY_NUMBER') + ': ']"
            :fieldWidthArr="[364, 364, 364, 364, 364]" :fieldSpanWidthArr="[102, 102, 102, 102, 102]">
            <Input class="Input" v-model="plasticQuotation.colorNo" slot="a" :disabled="true" />
            <Input class="Input" v-model="plasticQuotation.rmPrice" slot="b" :disabled="true" />
            <DatePicker class="Input" v-model="plasticQuotation.rmPriceDate" type="date" format="yyyy-MM-dd"
                :placeholder="$t('RM_PRICE_DATE')" slot="c" :disabled="true"></DatePicker>
            <Input class="Input" v-model="plasticQuotation.dyeCost" slot="d" :disabled="true" />
            <Input class="Input" v-model="plasticQuotation.cavity" slot="e" :disabled="true" />
        </FormRowTwo>
        <FormRowTwo
            :fieldNameArr="[$t('MACHINE_TONNAGE') + ': ', $t('HOURLY_RATE') + ': ', $t('CYCLE_TIME') + ': ', $t('REF_PRICE_CURRENCY') + ': ']"
            :fieldWidthArr="[364, 364, 364, 364]" :fieldSpanWidthArr="[102, 102, 102, 102]">>
            <Input class="Input" v-model="plasticQuotation.tonnage" slot="a" :disabled="true" />
            <Input class="Input" v-model="plasticQuotation.hourlyRate" slot="b" :disabled="true" />
            <Input class="Input" v-model="plasticQuotation.cycleTime" slot="c" :disabled="true" />
            <Input class="Input" style="color: red;" v-model="referencePrice" slot="d" :disabled="true" />
        </FormRowTwo>
        <FormRowTwo :fieldNameArr="[$t('')]">
            <Table width="600" border :columns="priceColumnList" :data="priceList" slot="a">
            </Table>
        </FormRowTwo>
    </div>
</template>

<script>
import { mapGetters } from "vuex"
import { mapActions } from "vuex"
import FormRowTwo from '@/components/FormRowTwo'

export default {
    name: "PlasticAttributes",
    components: {
        FormRowTwo
    },
    props: {
        plasticQuotation: {
            type: Object,
            default: () => null,
        },
        referencePrice: {
            type: String,
            default: () => "",
        },
        priceList: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            priceColumnList: [
                {
                    renderHeader: (h, params) => {
                        var text = this.$t('ITEM')
                        return h('div', {
                            domProps: {
                                innerHTML: text
                            }
                        })
                    },
                    render: (h, params) => {
                        let html = "<lable>" + this.$t(params.row.key) + "</lable>"
                        return h("div", {
                            domProps: {
                                innerHTML: html
                            }
                        });
                    },
                    align: 'center',
                    width: 200,
                },
                {
                    renderHeader: (h, params) => {
                        var text = this.$t('PRICE')
                        return h('div', {
                            domProps: {
                                innerHTML: text
                            }
                        })
                    },
                    render: (h, params) => {
                        let html = "<lable>" + this.$t(params.row.value) + "</lable>"
                        return h("div", {
                            domProps: {
                                innerHTML: html
                            }
                        });
                    },
                    align: 'center',
                    width: 200,
                }
            ]
        }
    },
    methods: {
        ...mapGetters(["getModalSize"]),
        ...mapActions([]),
    },
    computed: {
        modalSize() {
            return this.getModalSize()
        },
        resinType() {
            return this.plasticQuotation.resinType ? this.plasticQuotation.resinType.type : ''
        },
        resinVendor() {
            return this.plasticQuotation.resinVendor ? this.plasticQuotation.resinVendor.vendorName : ''
        },
        resinNo() {
            return this.plasticQuotation.resinNo ? this.plasticQuotation.resinNo.partNoDesc : ''
        },
        distributor() {
            return this.plasticQuotation.distributor ? this.plasticQuotation.distributor.vendorName : ''
        }
    },
}
</script>

<style scoped></style>
  